import { render, staticRenderFns } from "./TopicRow.vue?vue&type=template&id=5fd45d6e"
import script from "./TopicRow.vue?vue&type=script&lang=js"
export * from "./TopicRow.vue?vue&type=script&lang=js"
import style0 from "./TopicRow.vue?vue&type=style&index=0&id=5fd45d6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports